import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
  connect () {
    this.bind_element();
  }

  initialize() {
  }

  bind_element() {
    greenPOS.initDateRangePicker()
  }

  disconnect() {
  }
};
